import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { LogOut, Timer } from "lucide-react";

interface InactivityWarningProps {
  open: boolean;
  onStay: () => void;
  onLogout: () => void;
}

export function InactivityWarning({ open, onStay, onLogout }: InactivityWarningProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <Timer className="h-5 w-5 text-warning" />
            Are you still there?
          </AlertDialogTitle>
          <AlertDialogDescription>
            You'll be logged out in 5 minutes due to inactivity. Click "Stay Logged In" to continue your session.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={onLogout}>
            <LogOut className="mr-2 h-4 w-4" />
            Log Out Now
          </Button>
          <AlertDialogAction onClick={onStay}>
            Stay Logged In
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
